import styled from 'styled-components';

export const ItemName = styled.h3`
  margin-top: 0;
  text-align: center;
`;
